import './App.css';
import IndexRoutes from './Routes';
import '../src/Assets/css/style.css'
import Menu from './Pages/Utils/Menu';
import Header from './Pages/Utils/Header';
import AuthProtected from './Routes/AuthProtected'
import { UserProvider } from './hooks/UserProvider';

function App() {
  return (
    <div className="App">
      <UserProvider>
        <AuthProtected>
          <Header/>
            <IndexRoutes/>
          <Menu/> 
        </AuthProtected>
      </UserProvider>  
    </div>
  );
}

export default App;